import React, { memo } from 'react'
import clsx from 'clsx'
import { IconX } from '@tabler/icons'
import { Button } from '@mantine/core'
import styled from '@emotion/styled'
import { dayjsInit } from '@ow/utils'
import { convertTime } from '../utils'

const Container = styled.div`
  box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.1),
    0 8px 10px 1px rgba(0, 0, 0, 0.06), 0 3px 14px 2px rgba(0, 0, 0, 0.05);
  transition: bottom 0.3s ease-in-out;
`

const Header = ({ onClose }) => {
  return (
    <div className="flex items-center justify-between px-5 pt-4">
      <h3 className="text-base font-semibold">检查员详情</h3>
      <div className="cursor-pointer" onClick={onClose}>
        <IconX />
      </div>
    </div>
  )
}

const UserInfoModal = ({ user, onClick, onClose }) => {
  return (
    <Container
      className={clsx(
        'absolute bg-white w-full left-0 rounded-2xl z-[80] pb-12',
        user ? '-bottom-4' : '-bottom-full'
      )}
    >
      <Header onClose={onClose} />
      <div className="py-6 px-5">
        <div className="flex leading-7 gap-3">
          <p className="w-[98px] text-gray-300 flex-shrink-0">姓名</p>
          <p className="break-all">{user?.name}</p>
        </div>
        {user?.lastInspectTime && (
          <div className="flex leading-7 mt-2 gap-3">
            <p className="w-[98px] text-gray-300 shrink-0">最后上报时间</p>
            <p>{dayjsInit(user.lastInspectTime).format('HH:mm')}</p>
          </div>
        )}
        {user?.totalOnlineTime && (
          <div className="flex leading-7 mt-2 gap-3">
            <p className="w-[98px] text-gray-300 shrink-0">当天在线时长</p>
            <p>{convertTime(user.totalOnlineTime)}</p>
          </div>
        )}
        {user?.address && (
          <div className="flex leading-7 mt-2 gap-3">
            <p className="w-[98px] text-gray-300 shrink-0">当前位置</p>
            <p>{user.address}</p>
          </div>
        )}
        <div className="text-center mt-5">
          <Button
            className="px-16"
            variant="outline"
            onClick={() => onClick(user)}
          >
            查看详情
          </Button>
        </div>
      </div>
    </Container>
  )
}

export default memo(UserInfoModal)
